import { convertToTitleCaseAndCapitalizeFirst } from '../../../../utils/common';
import { ITemplateSearch } from '../../../@types/myAuditList';
import { ISelectedOption } from '../../../@types/searchBox';
import { IUser } from './../../../@types/myAudit';

export const filterOptions = (value: string, options: ISelectedOption[]) => {
  if (value) {
    const filtered = options.filter((option) =>
      option.text.toLowerCase().includes(value.toLowerCase())
    );
    return filtered;
  } else {
    return [];
  }
};

export const renderUserOptions = (searchBoxUserOptions: IUser[]) => {
  return searchBoxUserOptions.map(
    ({ userFirstName, userLastName, ...rest }) => ({
      ...rest,
      text: `${userFirstName} ${userLastName}`,
    })
  );
};

export const renderTemplateOptions = (
  searchBoxTemplateOptions: ITemplateSearch[]
) => {
  return searchBoxTemplateOptions.map(
    ({ templateName, type, ...templateData }) => ({
      ...templateData,
      text: `${templateName} (${convertToTitleCaseAndCapitalizeFirst(type)})`,
    })
  );
};

export const handleOptionClickUtil = (
  selected: ISelectedOption,
  selectedOptions: ISelectedOption[]
) => {
  if (!selectedOptions.some((option) => option.id === selected.id)) {
    return [
      {
        id: selected.id,
        text: selected.text,
      },
    ];
  }
  return [];
};
